<template>
<div class="comming-soon">
	<div class="container hero">
	<div class="inner">
			<h1>Beetronix Technical Solutions</h1>
			<h3>Our website is currently being upgraded to give you the best browsing experience.<br />
			Check back soon! (sooner than you think)</h3>
			 <!-- Start Animation img-->
			 <div class="row row-inner">
				 <div class="col-sm-6 col-xs-12 animation-section">
					<div class="animation-wrapper text-center">
					<div class="coming-soon-main"> <img src="src/assets/img/coming-soon-main.png" alt=""> </div>
					<div class="gear-animation"> <img src="src/assets/img/gear-lg.png" alt=""> </div>
					<div class="coming-soon-animated animated infinite shake"> <img src="src/assets/img/coming-soon-animated.png" alt=""> </div>
					</div>
        		</div>	
 				<div class="col-sm-6 col-xs-12 logo-section">
					 <div class="img-container">
						 	<div class="content">
								 	<img src="src/assets/img/logo.png">
							 </div>
					 </div>
					   <ul class="social">
								<li><a><span class="fa fa-facebook-square"></span></a></li>
								<li><a><span class="fa fa-envelope-o"></span></a></li>
								<li><a><span class="fa fa-twitter-square"></span></a></li>
						</ul>
						 <ul class="contact-list">
							<li><a href="mailto:info@beetronix.com" ><i class="fa fa-envelope"></i>info@beetronix.com</a></li>
							<li><a href="javascript://"><i class="fa fa-mobile"></i>00963-955-944-218</a></li>
						</ul>
					 
				 </div>
				 
			 </div>
				
				
          
          <!-- End Animation img--> 
	</div>
	<!-- <div class="overlay"></div> -->
	<div class="background">
		<canvas id="hero-canvas" width="1920" height="1080"></canvas>
	</div>
</div>
</div>
</template>
<script>
// import '../comming soon/hero-animation.js';
import "../comming soon/bezierCanvas.js";
export default {
  name: "comming-soon",
  mounted() {
    // Activate bezierCanvas plugin on a #bg-canvas element
    $("#hero-canvas").bezierCanvas({
      maxStyles: 1,
      maxLines: 100,
      lineSpacing: 1,
      colorBase: { r: 249, g: 160, b: 31 },
      colorVariation: { r: 0, g: 0, b: 0 },
      moveCenterX: 0,
      moveCenterY: 0,
      speedVariation: 0.3,
      globalAlpha: 1,
      globalSpeed: 300
    });
  }
};
</script>
<style lang="scss" scoped>
@import "src/assets/sass/mixins.scss";
@import "hero-animation.scss";
@import "consturction-animation.css";
.comming-soon {
  background-color: #000;

  .inner {
    h3 {
      color: rgba(5, 5, 5, 0.6);
      width: 50%;
      margin: 10px auto;
      @media (max-width: 767px) {
        font-size: 22px;
      }
    }
    h1 {
      @media (max-width: 767px) {
        font-size: 32px;
      }
    }
  }
  .logo-section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .img-container {
      width: 40%;
      @include aspect-ratio(3,3);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .social {
      margin-top: 20px;
      display: flex;
      padding-left: 0px;
      justify-content: center;
      width: 40%;
      li {
        display: inline-block;
        flex-grow: 1;
        a {
          color: #333;
          font-size: 18px;
        }
      }
    }
    .contact-list {
      margin-top: 10px;
      padding-left: 0px;
      li {
        margin: 10px auto;
        a {
          color: #333;
          font-size: 18px;
          i.fa {
            margin-left: 4px;
            margin-right: 4px;
          }
        }
      }
    }
  }

  .row-inner {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 30px;

    @media (max-width: 767px) {
      display: flex;
      flex-direction: column;
    }
    & > div {
      @media (max-width: 767px) {
        width: 100%;
      }
    }
    .animation-section {
      @media (max-width: 767px) {
        order: 1;
        margin-bottom: 20px;
      }
    }
    .logo-section {
      @media (max-width: 767px) {
        order: 2;
      }
    }
  }
}
.hero {
  h1 {
    color: #000;
  }
}
.navbar,
.footer {
  display: none;
}
.animation-wrapper {
  width: 100%;
  .coming-soon-main {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .coming-soon-animated {
    width: 50%;
    img {
      width: 100%;
    }
  }
  .gear-animation {
    width: 6%;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comming soon/comming-soon.vue